"use client";
import Image from "next/image";
import Link from "next/link";
import "../../css/Header.css";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export default function Header() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const pathname = usePathname();

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileOpen]);

  return (
    <header className={`basic-header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <Link href="/" className="header-logo">
          <Image
            src="/ca-logo.png"
            alt="CareAscenium"
            width={200}
            height={60}
            priority
            className="header-logo-img"
          />
        </Link>

        <nav className="header-nav">
          <div>
            <Link href="/" style={{ textDecoration: 'none' }}>
              Home
            </Link>
            <Link href="/about-us" className={pathname === "/about-us" ? "active" : ""}>About Us</Link>
            <Link href="/features" className={pathname === "/features" ? "active" : ""}>Features</Link>
            <Link
              href="/contact"
              className={pathname === "/contact" ? "active" : ""}
            >
              Contact Us
            </Link>
          </div>
          <div>
            {/* Use plain <a> for Login so navigation does a full page load and login page CSS applies correctly (avoids client-nav style reset). */}
            <a
              href="/login"
              className={`header-link-login ${
                pathname === "/login" ? "active" : ""
              }`}
            >
              Login
            </a>
            {/* Full page load so signup page CSS applies correctly (same as Login). */}
            {/* <a
              href="/signup"
              className={`header-link-register ${
                pathname === "/signup" ? "active" : ""
              }`}
            >
              Sign Up
            </a> */}
          </div>
        </nav>

        <button
          className="hamburger"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {isMobileOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </button>

        <nav className={`mobile-menu ${isMobileOpen ? "open" : ""}`}>
          <Link
            href="/"
            style={{ textDecoration: 'none' }}
            onClick={() => setIsMobileOpen(false)}
          >
            Home
          </Link>
          <Link href="/about-us" className={pathname === "/about-us" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>About Us</Link>
          <Link href="/features" className={pathname === "/features" ? "active" : ""} onClick={() => setIsMobileOpen(false)}>Features</Link>
          <Link
            href="/contact"
            className={pathname === "/contact" ? "active" : ""}
            onClick={() => setIsMobileOpen(false)}
          >
            Contact Us
          </Link>
          <a
            href="/login"
            className={`header-link-login ${
              pathname === "/login" ? "active" : ""
            }`}
            onClick={() => setIsMobileOpen(false)}
          >
            Login
          </a>
        </nav>
      </div>
    </header>
  );
}
